export const CREDIT_EVENTS = [
  {
    id: 'PHYSICAL_SETTLEMENT_MATRIX',
    displayValue: 'As per Physical Settlement Matrix',
  },
  { id: 'BANKRUPTCY', displayValue: 'Bankruptcy' },
  { id: 'FAILURE_TO_PAY', displayValue: 'Failure to Pay' },
  { id: 'GRACE_PERIOD_EXTENSION', displayValue: 'Grace Period Extension' },
  {
    id: 'GOVERNMENTAL_INTERVENTION',
    displayValue: 'Governmental Intervention',
  },
  { id: 'OBLIGATION_DEFAULT', displayValue: 'Obligation Default' },
  { id: 'OBLIGATION_ACCELERATION', displayValue: 'Obligation Acceleration' },
  { id: 'REPUDIATION_MORATORIUM', displayValue: 'Repudiation/Moratorium' },
  { id: 'RESTRUCTURING', displayValue: 'Restructuring' },
  {
    id: 'PROVISIONS_RELATING_TO_MULTIPLE_HOLDER_OBLIGATION',
    displayValue: 'Provisions relating to Multiple Holder Obligation',
  },
  { id: 'MOD_R', displayValue: 'Mod R' },
  { id: 'MOD_MOD_R', displayValue: 'Mod Mod R' },
];

export enum CreditEventId {
  PHYSICAL_SETTLEMENT_MATRIX = 'PHYSICAL_SETTLEMENT_MATRIX',
  BANKRUPTCY = 'BANKRUPTCY',
  FAILURE_TO_PAY = 'FAILURE_TO_PAY',
  GRACE_PERIOD_EXTENSION = 'GRACE_PERIOD_EXTENSION',
  GOVERNMENTAL_INTERVENTION = 'GOVERNMENTAL_INTERVENTION',
  OBLIGATION_DEFAULT = 'OBLIGATION_DEFAULT',
  OBLIGATION_ACCELERATION = 'OBLIGATION_ACCELERATION',
  REPUDIATION_MORATORIUM = 'REPUDIATION_MORATORIUM',
  RESTRUCTURING = 'RESTRUCTURING',
  PROVISIONS_RELATING_TO_MULTIPLE_HOLDER_OBLIGATION = 'PROVISIONS_RELATING_TO_MULTIPLE_HOLDER_OBLIGATION',
  MOD_R = 'MOD_R',
  MOD_MOD_R = 'MOD_MOD_R',
}
